import React from 'react';

import { useStyles } from './FilterSection.styles';

import { FilterSectionProps } from '../MoreResultsFilters.interfaces';
import FilterField from '../FilterField/FilterField';

export default function FilterSection({
  filterSectionOptions,
}: {
  filterSectionOptions: FilterSectionProps;
}) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.title}>{filterSectionOptions.title}</div>
      <div className={classes.items}>
        {filterSectionOptions.sections.map((section) => (
          <FilterField
            key={section.name}
            section={section}
            titleSection={filterSectionOptions.sectionName}
          />
        ))}
      </div>
    </div>
  );
}
